import React, { useMemo } from "react";
import { Col, Container, Form, Row } from "react-bootstrap";
import "react-phone-input-2/lib/style.css";
// css
import styles from "./addForm.module.scss";
import { Formik } from "formik";
import { useNavigate, useParams, Link, generatePath } from "react-router-dom";
import AppFileUploadField from "components/shared/FormComponents/AppFileUploadField";
import { isEmpty } from "lodash";
import { successMessageToast } from "helpers/common";
import { SCHOOL_BANNERS_LIST, SCHOOL_BANNERS_VIEW, THERAPIST_LIST } from "config/paths";
import ErrorComponent from "components/shared/ErrorComponent";
import LoadingIndicator from "components/shared/LoadingIndicator";
import { Breadcrumbs } from "components/Common/Common";
import { genericFormErrorMsg } from "utils/validation/validationHelpers";
import LoadingOverlay from "components/shared/LoadingOverlay";
import TextInput from "components/shared/FormComponents/V2/commonV2/TextInput";
import bannerSchema from "./addBannerForm.schema";
import CommonButton from "components/shared/FormComponents/V2/commonV2/CommonButton";
import AppDatePicker from "components/shared/FormComponents/AppDatePicker";
import CustomEditor from "components/TipTapEditor/CustomeEditor";
import { useCreateSchoolBannerMutation, useUpdateSchoolBannerMutation, useViewSchoolBannerQuery } from "store/services/schoolBanners";

const AddBanner = () => {
  const { id } = useParams();
  const editMode = !!id;
  const navigate = useNavigate();

  const {
    data: bannerData,
    isLoading: getSchoolBannerLoading,
    isError: getSchoolBannerError,
  } = useViewSchoolBannerQuery({ id }, { skip: !id });

  const [createSchoolBanner, { isLoading: createSchoolBannerLoading }] = useCreateSchoolBannerMutation();
  const [updateSchoolBanner, { isLoading: updateSchoolBannerLoading }] = useUpdateSchoolBannerMutation();

  const initialValues = useMemo(() => {
    // if (editMode && !bannerData) {
    //   return defaultInitialValues;
    // }
    if (editMode) {
      return ({
        title: bannerData?.title || "",
        description: bannerData?.description || "",
        link_url: bannerData?.link_url || "",
        from_date: bannerData?.from_date || null,
        to_date: bannerData?.to_date || null,
        banner_image: bannerData?.banner_image || "",
        status: bannerData?.status || ''
      })
    }
    else {
      return defaultInitialValues;
    }
  }, [bannerData])

  const handleSubmit = async (values) => {
    const body = {
      ...values,
    }
    try {
      const result = editMode ? await updateSchoolBanner({ id, data: body }).unwrap() : await createSchoolBanner({ data: body }).unwrap();
      successMessageToast(result?.message);
      navigate(SCHOOL_BANNERS_LIST);
    } catch (error) {
      console.log('error', error)
    }
  };

  const breadcrumbItems = [
    { label: "School Banners", path: SCHOOL_BANNERS_LIST },
    { label: editMode ? "Edit Banner" : "Add Banner" },
  ];

  return (
    <>
      {
        (updateSchoolBannerLoading || createSchoolBannerLoading) && <LoadingOverlay />
      }
      <section className={`${styles.addForm} position-relative py-0 addForm`}>
        <Container fluid={true}>
          <Row
            style={{
              width: '100%',
              // maxWidth: window.innerWidth >= 992 ? 'calc(100% - 170px)' : '100%',
              padding: '10px'
            }}
          >
            <Col lg={12} className="mt-2 mb-3">
              <div className="pageHead d-flex align-items-center justify-content-between flex-wrap">
                <Breadcrumbs themeBlueV2 items={breadcrumbItems} />
              </div>
              <div>
                {/* <h3 className="h5 mt-3">{editMode ? "Edit Clinician" : "Add Clinician"}</h3> */}
              </div>
            </Col>

            <Row className="mt-0 g-3">
              {getSchoolBannerLoading ? (
                <LoadingIndicator />
              ) : getSchoolBannerError ? (
                <ErrorComponent />
              ) : (
                <Formik
                  initialValues={initialValues}
                  validationSchema={bannerSchema}
                  onSubmit={handleSubmit}
                  enableReinitialize
                >
                  {({
                    handleSubmit,
                    isSubmitting,
                    errors,
                    submitCount,
                    values,
                    validateForm,
                    setFieldValue
                  }) => (
                    <Form onSubmit={handleSubmit} className="mt-0">
                      {console.log("Formik Values:", values)}
                      {console.log("Formik Errors:", errors)}
                      <div>
                        {/* <h3
                          className="h5 mb-0 text-uppercase fw-medium"
                          style={{ color: "#315d99", fontSize: "14px" }}
                        >
                          1. Clinician Information
                        </h3> */}
                        <div
                          className="py-2"
                        // style={{ borderTop: "1px solid #315D99" }}
                        >

                          <Row className="g-3 mt-0">
                            <Col lg={8} md={6} className="mt-0">
                              <TextInput
                                name="title"
                                label="Banner Title"
                                placeholder=""
                                required
                              />
                            </Col>

                            <Col lg={2} md={6} className="mt-0">
                              <div>
                                <label>From</label>
                                <AppDatePicker
                                  name="from_date"
                                  className="w-100 read-only"
                                />
                              </div>
                            </Col>
                            <Col lg={2} md={6} className="mt-0">
                              <div>
                                <label>To</label>
                                <AppDatePicker
                                  name="to_date"
                                  className="w-100 read-only"
                                />
                              </div>
                            </Col>
                          </Row>

                          <Row className="g-3">
                            <label>Description</label>
                            <Col md={8} sm={12} className="mt-0">
                              <CustomEditor name='description' />
                            </Col>
                            <Col className="d-none d-lg-block mt-0" lg={4} md={6}></Col>

                            <Col lg={8} md={6} className="mt-0">
                              <TextInput
                                name="link_url"
                                label="Link (optional)"
                                placeholder=""
                                required
                              />
                            </Col>

                            {/* <Col lg={3} md={6} className="mt-0 reports-v2 my-3 d-flex justify-content-end classroom-conslutation">
                              <div className="w-100 align-items-center gap-3">
                                <label className="discharge-screen-label mb-0">Timezone<span>*</span></label>
                                <CommonSelect
                                  placeholder={"Choose one..."}
                                  name="timezone"
                                  option={TIMEZONE_OPTIONS}
                                  value={values.timezone}
                                  onChange={(val) => setFieldValue("timezone", val)}
                                  isFilterV2
                                  styles={{
                                    container: (provided) => ({
                                      ...provided,
                                      width: "100%",
                                    }),
                                  }}
                                />
                              </div>
                            </Col> */}
                          </Row>

                          <Row className="g-3 mt-3">
                            <Col lg={8} md={6} className="mt-0">
                              <label>Banner Image</label>
                              <div className="d-flex gap-2 align-items-center w-100">
                                <span className="w-50" style={{ color: 'black', fontSize: '12px', fontWeight: 400 }}>Upload a JPG or PNG, Mazimum size: 2MB</span>
                                <div className="w-100">
                                  {/* <AppFileUploadField
                                    name="firstname"
                                    label="Link (optional)"
                                    placeholder=""
                                    className="read-only w-100 p-1"
                                    style={{ border: '1px black solid' }}
                                    accept={MIME_TYPES.images}
                                  /> */}
                                  <AppFileUploadField
                                    name="banner_image"
                                    acl={"public-read"}
                                    // accept="application/pdf"
                                    // allowedTypes={[MIME_TYPES.jpeg, MIME_TYPES.png,  MIME_TYPES.jpg]}
                                    multiple={false}
                                    preview={true}
                                    className={`readonly-box h-auto`}

                                  />
                                </div>
                              </div>
                            </Col>
                          </Row>
                        </div>
                      </div>

                      {/* <div className="mt-4">
                        <h3
                          className="h5 mb-0  text-uppercase fw-medium"
                          style={{ color: "#315d99", fontSize: "14px" }}
                        >
                          2. KCS INFORMATION
                        </h3>

                        <div
                          className="py-3"
                          style={{ borderTop: "1px solid #315D99" }}
                        >
                          <Row className="g-3">

                            <Col lg={12} md={12}>
                              <div className="d-flex gap-2 flex-wrap">
                                <ChipSelect
                                  name="discipline_id"
                                  label="Discipline"
                                  required
                                  options={disciplinesList}
                                />
                              </div>
                            </Col>
                          </Row>

                          <Row className="g-3 mt-1 align-items-start">
                            <Col lg={4} md={6} className="reports-v2 my-3  classroom-conslutation">
                              <label className="mb-1 fw-semibold" style={{ fontSize: "12px" }}>
                                Designation<span>*</span>
                              </label>
                              <CommonSelect
                                placeholder=""
                                name="designation_id"
                                option={
                                  designationsList?.length && designationsList?.map((item) => ({
                                    value: item.id,
                                    label: item.title,
                                  }))
                                }
                                isFilterV2
                              />
                            </Col>

                            <Col lg={4} md={6} className="reports-v2 my-3  classroom-conslutation">
                              <label className="mb-1 fw-semibold" style={{ fontSize: "12px" }}>
                                Type<span>*</span>
                              </label>

                              <CommonSelect
                                placeholder=""
                                name="type"
                                isFilterV2
                                value={values.type ? { label: values.type, value: values.type } : null}
                                onChange={(val) => setFieldValue("type", val?.value || "")}

                                option={[
                                  { label: "Veteran", value: "veteran" },
                                  { label: "Apprentice", value: "apprentice" },
                                ]}
                                styles={{
                                  container: (provided) => ({
                                    ...provided,
                                    width: "100%",
                                  }),
                                }}
                              />
                            </Col>

                            <Col lg={4} md={12}>
                              <CheckboxMultiSelect
                                name="assigned_client_category"
                                label="Client Type"
                                required
                                options={CLIENT_TYPE_OPTIONS}
                              />
                            </Col>
                          </Row>
                        </div>
                      </div> */}

                      {/* <div className="mt-4">
                        <h3 className="h5 mb-0 text-uppercase fw-medium" style={{ color: "#315d99", fontSize: "14px" }}>
                          3.   ASSIGN SCHOOLS FOR CLASSROOM REPORTS
                        </h3>
                        <div style={{ borderTop: "1px solid #315D99" }}>
                          <FieldArray name="assign_schools" >
                            {({ push, remove }) => (
                              <>
                                {values.assign_schools?.map((_, index) => (
                                  <Row className="g-3 align-items-end reports-v2 my-1  classroom-conslutation" key={index}>
                                    <div className="d-flex gap-3 align-items-end">
                                      <div className="w-100">
                                        <label className="mb-1 fw-semibold" style={{ fontSize: "12px" }}>
                                          School Division
                                        </label>
                                        <CommonSelect
                                          placeholder=""
                                          value={values.assign_schools[index].division}
                                          option={
                                            schoolDivisionsList?.length && schoolDivisionsList?.map(item => ({
                                              value: item.id,
                                              label: item.title,
                                            }))
                                          }
                                          onChange={(val) => setFieldValue(`assign_schools[${index}].division`, val)}
                                          isClearable
                                          isFilterV2

                                        />
                                      </div>
                                      <div className="w-100">
                                        <label className="mb-1 fw-semibold" style={{ fontSize: "12px" }}>
                                          School Name
                                        </label>
                                        <CommonSelect
                                          placeholder=""
                                          value={values.assign_schools[index].name}
                                          onChange={(val) => setFieldValue(`assign_schools[${index}].name`, val)}
                                          isClearable
                                          isFilterV2
                                          option={(() => {
                                            const divisionId = values.assign_schools[index].division?.value;

                                            if (!divisionId) return [];

                                            const selectedSchoolIds = values?.assign_schools?.filter(
                                              (item) => item?.division?.value === divisionId
                                            ).map((item) => item?.name?.value)

                                            const divisionObj = schoolDivisionsList?.find(d => d.id === divisionId);

                                            if (!divisionObj?.schools?.length) return [];

                                            return cloneDeep(divisionObj.schools)
                                              .filter(
                                                (school) =>
                                                  !selectedSchoolIds.includes(school.id)
                                              )
                                              .sort((a, b) => a.name.localeCompare(b.name))
                                              .map((school) => ({
                                                value: school.id,
                                                label: school.name,
                                              }));
                                          })()}
                                        />
                                      </div>

                                      <div style={{ width: "24px" }}>
                                        {index > 0 ? (
                                          <Button
                                            onClick={() => remove(index)}
                                            variant="link"
                                            className="p-0 border-0 mb-2"
                                          >
                                            <CrossIcon classes="text-danger" />
                                          </Button>
                                        ) : null}
                                      </div>

                                    </div>
                                  </Row>
                                ))}

                                <CommonButton
                                  className="mt-4"
                                  text="Add Another"
                                  onClick={(e) => {
                                    e.preventDefault()
                                    push({ division: null, name: null })
                                  }} />

                              </>
                            )}
                          </FieldArray>
                        </div>
                      </div> */}

                      {!isEmpty(errors) && submitCount > 0 && (
                        <Row className="mt-4">
                          <Col lg="12">
                            <span className="error">{genericFormErrorMsg}</span>
                          </Col>
                        </Row>
                      )}

                      <Row style={{ marginTop: "55px" }}>
                        {/* <Col>
                          <div style={{ background: "#315D991A", textAlign: "center", padding: "27px", borderRadius: "12px" }}>
                            <p style={{ color: "#315D99", margin: 0 }}>Account will become active when the user accepts the KCS Policies.</p>
                          </div>
                        </Col> */}
                        <Col lg="12">
                          <div
                            style={{ borderTop: "1px solid #315D99" }}
                            className={`${styles.btnWrpper} d-flex align-items-center justify-content-between gap-10 pt-3`}

                          >
                            <div className="d-flex gap-2">
                              <CommonButton text="Save as Draft" disabled={createSchoolBannerLoading || updateSchoolBannerLoading} onClick={() => {
                                setFieldValue('status', 'draft')
                                handleSubmit()
                              }} />
                              <CommonButton text="Archive" type='submit' disabled={createSchoolBannerLoading || updateSchoolBannerLoading} onClick={() => {
                                setFieldValue('status', 'archived')
                                handleSubmit()
                              }} />
                             {
                              id &&  <CommonButton text="Preview" type='button' disabled={createSchoolBannerLoading || updateSchoolBannerLoading} onClick={() => {
                                navigate(generatePath(SCHOOL_BANNERS_VIEW, { id: id }))
                              }} />
                             }
                            </div>
                            <CommonButton
                              type="submit"
                              text="Publish Banner"
                              disabled={createSchoolBannerLoading || updateSchoolBannerLoading}
                              style={{ color: "#fff", background: "#315D99" }}
                              onClick={() => {
                                setFieldValue('status', 'published')
                                validateForm().then((validationErrors) => {
                                  const fieldOrder = [
                                    "firstName",
                                    "lastName",
                                    "email",
                                    "phone",
                                    "addressLine1",
                                    "state",
                                    "addressLine2",
                                    "city",
                                    "postalCode",
                                  ];

                                  const errorKey = Object.keys(validationErrors || {})
                                    .sort(
                                      (a, b) =>
                                        fieldOrder.indexOf(a) -
                                        fieldOrder.indexOf(b)
                                    )[0];

                                  if (errorKey) {
                                    const el = document.querySelector(
                                      `[name="${errorKey}"]`
                                    );
                                    el?.scrollIntoView({
                                      behavior: "smooth",
                                      block: "center",
                                    });
                                    el?.focus();
                                  }
                                });
                              }}
                            />
                          </div>
                        </Col>
                      </Row>

                      {console.log("Formik Values:", values)}
                    </Form>
                  )}
                </Formik>
              )}
            </Row>
          </Row>
        </Container>
      </section>
    </>
  );
};

const defaultInitialValues = {
  title: "",
  description: "",
  link_url: "",
  from_date: null,
  to_date: null,
  banner_image: "",
  status: ''
};

export default AddBanner;
